import React from "react";

import {
  addDoc,
  collection,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  startAfter,
} from "firebase/firestore";

import app from "../firebase";

import { getStorage } from "firebase/storage";
import { BodyErrorLogType } from "../../types/database";
import { Dev } from "../util/consoleUtil";
import firebaseError from "../util/firebaseError";

const db = getFirestore(app);
const storage = getStorage(app);

export const ErrorLogService = {
  LazyList: (definedLimit: number = 5) => {
    const [isLoading, setLoading] = React.useState(false);
    const [hasMore, setHasMore] = React.useState(false);

    const [lastItemRef, setLastItemRef] = React.useState<any>(null);

    const [items, setItems] = React.useState<BodyErrorLogType[]>([]);

    const runRequest = async (restart?: boolean) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);

          const mainRef = collection(db, "errorLogs");

          const args = [orderBy("createdAtTimestamp", "desc")] as any[];

          if (lastItemRef && !restart) {
            args.push(startAfter(lastItemRef));
          }

          args.push(limit(definedLimit));

          const queryRef = query(mainRef, ...args);

          const mainSnap = await getDocs(queryRef);

          setLastItemRef(mainSnap.docs[mainSnap.docs.length - 1] || null);

          const listData = [] as BodyErrorLogType[];

          mainSnap.forEach((doc) => {
            listData.push({ id: doc.id, ...doc.data() } as BodyErrorLogType);
          });

          setItems(restart ? [...listData] : [...items, ...listData]);

          if (listData.length < definedLimit) setHasMore(false);
          else setHasMore(true);

          setLoading(false);

          Ok(listData);
        } catch (error) {
          console.log(...new Dev("Request Error [list]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao obter dados. " + firebaseError(error)));
        }
      });
    };

    return { items, isLoading, runRequest, hasMore };
  },

  Create: () => {
    const [isLoading, setLoading] = React.useState(false);

    const runRequest = async (item: BodyErrorLogType) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);

          const mainRef = collection(db, "errorLogs");
          const mainSnap = await addDoc(mainRef, item);

          setLoading(false);
          Ok(true);
        } catch (error) {
          console.log(...new Dev("Request Error [create]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao criar dados. " + firebaseError(error)));
        }
      });
    };

    return { isLoading, runRequest };
  },
};
